import { render, staticRenderFns } from "./UpdateLocation.vue?vue&type=template&id=23a5ac75&"
import script from "./UpdateLocation.vue?vue&type=script&lang=js&"
export * from "./UpdateLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports